class Identity {
  // name: teacher / assist / student
  constructor(name, state) {
    this.name = name;
    this.state = state;
  }

  // 是否有发布权限
  canDispatch() {
    if (this.name == 'teacher') {
      return this.state.commonSetting.teacher_dispatch;
    } else if (this.name == 'assist') {
      return this.state.commonSetting.assist_dispatch;
    }
    return false;
  }

  // 是否有批改权限
  canCorrect() {
    if (this.name == 'teacher') {
      return this.state.commonSetting.teacher_correct;
    } else if (this.name == 'assist') {
      return this.state.commonSetting.assist_correct;
    }
    return false;
  }
}

export default Identity;